import OrderDraggable from "./OrderDraggable";
import ServicesDraggable from "./ServicesDraggable";
import EditOrderDraggable from "./EditOrderDraggable";
export default {
    OrderDraggable,
    ServicesDraggable,
    EditOrderDraggable
}